// Import model
import { StartEstimateRequestSignatureRequest } from '../models/StartEstimateRequestSignatureRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for StartEstimateRequestSignatureRequest - handles JSON serialization and deserialization with type validation
 */
export class StartEstimateRequestSignatureRequestSerializer {
  /**
   * Deserializes a JSON string into a StartEstimateRequestSignatureRequest instance
   */
  static deserialize(json: string): StartEstimateRequestSignatureRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a StartEstimateRequestSignatureRequest instance
   */
  static fromObject(obj: any): StartEstimateRequestSignatureRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to StartEstimateRequestSignatureRequest');
    }


    const instance: StartEstimateRequestSignatureRequest = {
      templateId: obj['TemplateId'] as string | undefined,
      submitterEmail: obj['SubmitterEmail'] as string | undefined,
      submitterName: obj['SubmitterName'] as string | undefined,
      name: obj['Name'] as string | undefined,
      submitterRole: obj['SubmitterRole'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of StartEstimateRequestSignatureRequest instances
   */
  static deserializeArray(json: string): StartEstimateRequestSignatureRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a StartEstimateRequestSignatureRequest instance to a JSON string
   */
  static serialize(instance: StartEstimateRequestSignatureRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a StartEstimateRequestSignatureRequest instance to a plain object
   */
  static toObject(instance: StartEstimateRequestSignatureRequest): any {
    return {
      'TemplateId': instance.templateId,
      'SubmitterEmail': instance.submitterEmail,
      'SubmitterName': instance.submitterName,
      'Name': instance.name,
      'SubmitterRole': instance.submitterRole,
    };
  }

  /**
   * Serializes an array of StartEstimateRequestSignatureRequest instances to a JSON string
   */
  static serializeArray(instances: StartEstimateRequestSignatureRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
